import React, { useEffect, useState } from 'react'
import Toggle from '../ui/Toggle'
import { IWorkingHoursItem } from 'src/types'
import ServiceWorkingHoursItem from 'src/containers/services/ServiceWorkingHoursItem'
import DriverWorkingHoursItem from './DriverWorkingHoursItem'
import { DAYS_OF_WEEK } from 'src/state/constants'
import { IDriverSchedule } from './DriverViewSchedule'

export interface IDriverWorkingHoursProps {
  driverId: string
  workingHoursList: IDriverSchedule[]
  setWorkingHoursList: (value: IDriverSchedule[]) => void
  workingHoursListErrors: IDriverSchedule[]
  setWorkingHoursListErrors: (value: IDriverSchedule[]) => void
}

const DriverWorkingHours = (props: IDriverWorkingHoursProps) => {
  const { workingHoursList, setWorkingHoursList, workingHoursListErrors, setWorkingHoursListErrors, driverId } = props
  const [tempFrom, setTempFrom] = useState<string>('')

  const handleAddClick = (driverId: string) => () => {
    const emptyWorkingHours = createEmptyWorkingHours(driverId)
    const updatedWorkingHours = [...workingHoursList, emptyWorkingHours]

    setWorkingHoursList(updatedWorkingHours)
  }

  const createEmptyWorkingHours = (driverId: string) => {
    return {
      from: '',
      until: '',
      days: [],
      is_archived: false
    }
  }

  const onRemoveClick = (index: number) => {
    const updatedWorkingHours = [...workingHoursList]
    updatedWorkingHours.splice(index, 1)
    setWorkingHoursList(updatedWorkingHours)
  }

  const onSetFrom = (index: number, from: string, until: string) => {
    const updatedWorkingHours = workingHoursList.map((workingHour, workingHourIndex) => {
      if (workingHourIndex === index) {
        return {
          ...workingHour,
          from,
          until
        }
      } else {
        return workingHour
      }
    })

    setWorkingHoursList(updatedWorkingHours)
  }

  const onSetUntil = (index: number, from: string, until: string) => {
    const updatedWorkingHours = workingHoursList.map((workingHour, workingHourIndex) => {
      if (workingHourIndex === index) {
        return {
          ...workingHour,
          from,
          until
        }
      } else {
        return workingHour
      }
    })

    setWorkingHoursList(updatedWorkingHours)
  }

  const onSetDays = (index: number, days: string[]) => {
    const updatedWorkingHours = workingHoursList.map((workingHour, workingHourIndex) => {
      if (workingHourIndex === index) {
        const sortedDays = days.sort((a, b) => a.localeCompare(b))
        return {
          ...workingHour,
          days: sortedDays
        }
      } else {
        return workingHour
      }
    })

    setWorkingHoursList(updatedWorkingHours)
  }

  const checkIfIncludes = (errorDays: string[], workingHourDays: string[]) => {
    if (errorDays.length === 0) {
      return false
    } else {
      const hasError = errorDays.some(day => {
        return workingHourDays.includes(day)
      })

      return hasError
    }
  }

  const retrieveErrorsDays = (workingHour: IDriverSchedule) => {
    const workingHourWithError = workingHoursListErrors.find(filtered => {
      return (
        checkIfIncludes(filtered.errorDays !== undefined ? filtered.errorDays : [], workingHour.days) &&
        filtered.from === workingHour.from &&
        filtered.until === workingHour.until
      )
    })

    if (workingHourWithError !== undefined) {
      return workingHourWithError.errorDays !== undefined ? workingHourWithError.errorDays : []
    } else {
      return []
    }
  }

  return (
    <div>
      <React.Fragment>
        {Object.values(workingHoursList).map((it, index) => (
          <DriverWorkingHoursItem
            key={`working-hours-${index}-${it.from}-${it.until}-${JSON.stringify(it.days)}`}
            index={index}
            workingHoursItem={it}
            onRemoveClick={onRemoveClick}
            onSetFrom={onSetFrom}
            onSetDays={onSetDays}
            onSetUntil={onSetUntil}
            errorDays={retrieveErrorsDays(it)}
          />
        ))}
        <button className='custom-btn mbsc-green-btn mt2' onClick={handleAddClick(driverId)}>
          + Add Schedule
        </button>
      </React.Fragment>
    </div>
  )
}

export default DriverWorkingHours



// WEBPACK FOOTER //
// ./src/components/drivers/DriverWorkingHours.tsx